import SwiperCore, { Pagination, Lazy } from 'swiper';

let initialized = false;

export function initSwiper(): void {
  if (initialized) return;
  SwiperCore.use([Pagination, Lazy]);
  initialized = true;
}
